import { takeLatest, put, select } from 'redux-saga/effects';
import { delay } from 'redux-saga';

import {
  NOTIFICATION_SUCCESS,
  NOTIFICATION_ERROR,
  NOTIFICATION_WARNING,
  NOTIFICATION_INFO,
} from '../actions/notifications/constants';
import {
  reset,
  onClickNotif,
  onNotificationReseted,
} from '../actions/notifications';

const getNotifications = (state) => state.notification.bars;

export function* resetNotification() {
  yield put(onClickNotif(false));
  yield delay(4000, true);

  // check any restoreNotification available
  let restoreNotification: any = null;
  const notificationList = yield select(getNotifications);
  if (!notificationList === false) {
    if (Array.isArray(notificationList) && notificationList.length > 0) {
      for (let index = notificationList.length - 1; index >= 0; index--) {
        const notification = notificationList[index];
        if (notification && notification.restoreNotification) {
          restoreNotification = notification.restoreNotification;
          break;
        } else if (notification && notification.closeable === false) {
          restoreNotification = notification;
          break;
        }
      }
    }
  }
  yield put(reset());
  if (!restoreNotification === false)
    yield put(onNotificationReseted(restoreNotification));
}

export default function* saga() {
  yield takeLatest(NOTIFICATION_SUCCESS, resetNotification);
  yield takeLatest(NOTIFICATION_ERROR, resetNotification);
  yield takeLatest(NOTIFICATION_WARNING, resetNotification);
  yield takeLatest(NOTIFICATION_INFO, resetNotification);
}
